import styled from '@emotion/styled';

export const TimeTrackerContainer = styled('div')(({ theme }) => ({
	position: 'fixed',
	left: 170,
	top: 0,
	zIndex: 1200,
	display: 'inline-flex',
	alignItems: 'center',
	gap: 10,
	height: theme.palette.novotalk.navigationBarHeight,
	padding: '0 12px',
	width: 'fit-content',
	maxWidth: 'fit-content',
	backdropFilter: 'blur(2px)',
	'@media (max-width: 1000px)': {
		left: 150,
		padding: '0 8px',
	},
}));

export const TimeTrackerValue = styled('div')(({ theme }) => ({
	minWidth: 92,
	padding: '6px 10px',
	borderRadius: 14,
	border: '1px solid rgba(255, 255, 255, 0.45)',
	backgroundColor: 'rgba(255, 255, 255, 0.14)',
	fontFamily: 'monospace',
	fontWeight: 800,
	fontSize: 17,
	letterSpacing: 1,
	color: theme.palette.novotalk.$textColorReversed,
	textAlign: 'center',
	textShadow: '0 1px 2px rgba(0, 0, 0, 0.35)',
}));

export const TimeTrackerActionButton = styled('button')(({ theme }) => ({
	width: 36,
	height: 36,
	borderRadius: '50%',
	border: '1px solid rgba(255, 255, 255, 0.58)',
	background: 'linear-gradient(180deg, rgba(255, 255, 255, 0.3) 0%, rgba(255, 255, 255, 0.14) 100%)',
	color: theme.palette.novotalk.$textColorReversed,
	display: 'inline-flex',
	alignItems: 'center',
	justifyContent: 'center',
	cursor: 'pointer',
	boxShadow: '0 2px 6px rgba(0, 0, 0, 0.16), inset 0 1px 0 rgba(255, 255, 255, 0.2)',
	transition: 'background-color 120ms ease-in-out, border-color 120ms ease-in-out, transform 120ms ease-in-out',
	'&:hover': {
		backgroundColor: 'rgba(255, 255, 255, 0.26)',
		borderColor: 'rgba(255, 255, 255, 0.8)',
	},
	'&:active': {
		backgroundColor: 'rgba(0, 97, 127, 0.4)',
		transform: 'scale(0.96)',
	},
	'&:disabled': {
		opacity: 0.45,
		cursor: 'not-allowed',
	},
}));
